function parseTimeEstimateMinutes(timeEstimate: string | null): number {
  if (!timeEstimate) return 0;
  const rangeMatch = timeEstimate.match(/(\d+)\s*[-~〜]\s*(\d+)/);
  if (rangeMatch) return Number(rangeMatch[2]);
  const singleMatch = timeEstimate.match(/(\d+)/);
  if (singleMatch) return Number(singleMatch[1]);
  return 0;
}

export function calculateElapsedTimes(
  items: { timeEstimate: string | null }[],
): number[] {
  let cumulative = 0;
  return items.map((item) => {
    cumulative += parseTimeEstimateMinutes(item.timeEstimate);
    return cumulative;
  });
}
